/**
 * Maximum width in CSS pixels for a single canvas chunk.
 * Canvas elements are split into chunks of this width to enable
 * horizontal virtual scrolling — only visible chunks are mounted.
 */
export const MAX_CANVAS_WIDTH = 1000;
